module.exports = __webpack_public_path__ + "img/update50-01.8d45c9f4.svg";